import * as gzTime from './time.service';

export default angular.module('gazelle.components.time', [
  'angularMoment',
  'rhino.core',
  'rhino.components.preferences',
])
  .service(gzTime.name, gzTime.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/time/time.module.js